export const connectionsConstants = {
  GET_ALL_CONNECTIONS_REQUEST: "GET_ALL_CONNECTIONS_REQUEST",
  GET_ALL_CONNECTIONS_SUCCESS: "GET_ALL_CONNECTIONS_SUCCESS",
  GET_ALL_CONNECTIONS_FAILURE: "GET_ALL_CONNECTIONS_FAILURE",

  GET_TOP_CARDS_CONNECTIONS_REQUEST: "GET_TOP_CARDS_CONNECTIONS_REQUEST",
  GET_TOP_CARDS_CONNECTIONS_SUCCESS: "GET_TOP_CARDS_CONNECTIONS_SUCCESS",
  GET_TOP_CARDS_CONNECTIONS_FAILURE: "GET_TOP_CARDS_CONNECTIONS_FAILURE",

  GET_FETCH_ACTIVE_SOURCE_DESTINATION_REQUEST:
    "GET_FETCH_ACTIVE_SOURCE_DESTINATION_REQUEST",
  GET_FETCH_ACTIVE_SOURCE_DESTINATION_SUCCESS:
    "GET_FETCH_ACTIVE_SOURCE_DESTINATION_SUCCESS",
  GET_FETCH_ACTIVE_SOURCE_DESTINATION_FAILURE:
    "GET_FETCH_ACTIVE_SOURCE_DESTINATION_FAILURE",

  ADD_CONNECTION_REQUEST: "ADD_CONNECTION_REQUEST",
  ADD_CONNECTION_SUCCESS: "ADD_CONNECTION_SUCCESS",
  ADD_CONNECTION_FAILURE: "ADD_CONNECTION_FAILURE",

  GET_CONNECTION_BY_ID_REQUEST: "GET_CONNECTION_BY_ID_REQUEST",
  GET_CONNECTION_BY_ID_SUCCESS: "GET_CONNECTION_BY_ID_SUCCESS",
  GET_CONNECTION_BY_ID_FAILURE: "GET_CONNECTION_BY_ID_FAILURE",

  GET_CONNECTION_BY_WORKSPACE_ID_REQUEST:
    "GET_CONNECTION_BY_WORKSPACE_ID_REQUEST",
  GET_CONNECTION_BY_WORKSPACE_ID_SUCCESS:
    "GET_CONNECTION_BY_WORKSPACE_ID_SUCCESS",
  GET_CONNECTION_BY_WORKSPACE_ID_FAILURE:
    "GET_CONNECTION_BY_WORKSPACE_ID_FAILURE",

  GET_ENDPOINTS_BY_CONNECTION_ID_REQUEST:
    "GET_ENDPOINTS_BY_CONNECTION_ID_REQUEST",
  GET_ENDPOINTS_BY_CONNECTION_ID_SUCCESS:
    "GET_ENDPOINTS_BY_CONNECTION_ID_SUCCESS",
  GET_ENDPOINTS_BY_CONNECTION_ID_FAILURE:
    "GET_ENDPOINTS_BY_CONNECTION_ID_FAILURE",

  CONFIGURE_CONNECTION_BY_CONNECTION_ID_REQUEST:
    "CONFIGURE_CONNECTION_BY_CONNECTION_ID_REQUEST",
  CONFIGURE_CONNECTION_BY_CONNECTION_ID_SUCCESS:
    "CONFIGURE_CONNECTION_BY_CONNECTION_ID_SUCCESS",
  CONFIGURE_CONNECTION_BY_CONNECTION_ID_FAILURE:
    "CONFIGURE_CONNECTION_BY_CONNECTION_ID_FAILURE",

  EDIT_CONNECTION_BY_ID_REQUEST: "EDIT_CONNECTION_BY_ID_REQUEST",
  EDIT_CONNECTION_BY_ID_SUCCESS: "EDIT_CONNECTION_BY_ID_SUCCESS",
  EDIT_CONNECTION_BY_ID_FAILURE: "EDIT_CONNECTION_BY_ID_FAILURE",

  FETCH_SLACK_LIST_INTEGRATION_REQUEST: "FETCH_SLACK_LIST_INTEGRATION_REQUEST",
  FETCH_SLACK_LIST_INTEGRATION_SUCCESS: "FETCH_SLACK_LIST_INTEGRATION_SUCCESS",
  FETCH_SLACK_LIST_INTEGRATION_FAILURE: "FETCH_SLACK_LIST_INTEGRATION_FAILURE",

  FETCH_BITBUCKET_INTEGRATION_REQUEST: "FETCH_BITBUCKET_INTEGRATION_REQUEST",
  FETCH_BITBUCKET_INTEGRATION_SUCCESS: "FETCH_BITBUCKET_INTEGRATION_SUCCESS",
  FETCH_BITBUCKET_INTEGRATION_FAILURE: "FETCH_BITBUCKET_INTEGRATION_FAILURE",

  FETCH_GIT_REPO_BY_CONNECTION_ID_REQUEST:
    "FETCH_GIT_REPO_BY_CONNECTION_ID_REQUEST",
  FETCH_GIT_REPO_BY_CONNECTION_ID_SUCCESS:
    "FETCH_GIT_REPO_BY_CONNECTION_ID_SUCCESS",
  FETCH_GIT_REPO_BY_CONNECTION_ID_FAILURE:
    "FETCH_GIT_REPO_BY_CONNECTION_ID_FAILURE",

    GET_CONNECTIONS_FILTERS_REQUEST: "GET_CONNECTIONS_FILTERS_REQUEST",
  GET_CONNECTIONS_FILTERS_SUCCESS: "GET_CONNECTIONS_FILTERS_SUCCESS",
  GET_CONNECTIONS_FILTERS_FAILURE: "GET_CONNECTIONS_FILTERS_FAILURE",

  ACTIVATE_CONNECTION_REQUEST: "ACTIVATE_CONNECTION_REQUEST",
  ACTIVATE_CONNECTION_SUCCESS: "ACTIVATE_CONNECTION_SUCCESS",
  ACTIVATE_CONNECTION_FAILURE: "ACTIVATE_CONNECTION_FAILURE",
};
